import React from "react"
import styled from "styled-components"

const ContactSection = styled.section`
  padding: var(--xl) 0;
  background: var(--heading);
  color: var(--white);
  .col-md-4 {
    text-align: center;
  }
  a {
    color: var(--white);
  }
  address {
    font-style: normal;
  }
  svg {
    margin: 0 var(--small);
  }
`

const ContactHeading = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  padding-bottom: var(--medium);
  @media (max-width: 640px) {
    padding-top: var(--large);
    padding-bottom: var(--small);
  }
`

const ContactInfo = () => {
  return (
    <ContactSection>
      <div className="container grid">
        <div className="col-md-4">
          <ContactHeading className="uppercase" style={{ paddingTop: 0 }}>
            Adresse
          </ContactHeading>
          <address>
            Rue Mauborget 1, 2 éme étage
            <br />
            1003 Lausanne
          </address>
        </div>
        <div className="col-md-4">
          <ContactHeading className="uppercase">Contact</ContactHeading>
          <a href="tel:0766802398">076 680 23 98</a>
          <br />
          <a href="mailto:espace.elsa@bluewin.ch">espace.elsa@bluewin.ch</a>
        </div>
        <div className="col-md-4">
          <ContactHeading className="uppercase">Social</ContactHeading>
          <a
            href="https://www.facebook.com/ELSA-Massothérapie-Bien-être-100910418295638"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.8 0H1.2C0.53625 0 0 0.53625 0 1.2V28.8C0 29.4638 0.53625 30 1.2 30H28.8C29.4638 30 30 29.4638 30 28.8V1.2C30 0.53625 29.4638 0 28.8 0ZM25.335 8.75625H22.9388C21.06 8.75625 20.6963 9.64875 20.6963 10.9613V13.8525H25.1813L24.5963 18.3787H20.6963V30H16.02V18.3825H12.1088V13.8525H16.02V10.515C16.02 6.64125 18.3863 4.53 21.8438 4.53C23.5013 4.53 24.9225 4.65375 25.3388 4.71V8.75625H25.335Z"
                fill="white"
              />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/elsa__massotherapie/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="32"
              height="30"
              viewBox="0 0 32 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5131 7.30355C11.1072 7.30355 7.55137 10.7409 7.55137 15C7.55137 19.2591 11.1072 22.6964 15.5131 22.6964C19.919 22.6964 23.4748 19.2591 23.4748 15C23.4748 10.7409 19.919 7.30355 15.5131 7.30355ZM15.5131 20.0021C12.6638 20.0021 10.3386 17.7544 10.3386 15C10.3386 12.2456 12.6638 9.99787 15.5131 9.99787C18.3624 9.99787 20.6876 12.2456 20.6876 15C20.6876 17.7544 18.3624 20.0021 15.5131 20.0021ZM23.8008 5.19462C22.7722 5.19462 21.9414 5.99767 21.9414 6.99209C21.9414 7.98651 22.7722 8.78955 23.8008 8.78955C24.8295 8.78955 25.6603 7.99026 25.6603 6.99209C25.6606 6.75596 25.6127 6.52209 25.5193 6.30388C25.426 6.08567 25.2891 5.8874 25.1163 5.72043C24.9436 5.55346 24.7385 5.42107 24.5128 5.33085C24.287 5.24062 24.0451 5.19433 23.8008 5.19462ZM31.0328 15C31.0328 12.9286 31.0522 10.876 30.9318 8.80832C30.8115 6.40669 30.2447 4.27525 28.428 2.51907C26.6074 0.759128 24.4064 0.215011 21.922 0.098682C19.7792 -0.0176466 17.6559 0.00111617 15.517 0.00111617C13.3742 0.00111617 11.2508 -0.0176466 9.11188 0.098682C6.62749 0.215011 4.42259 0.762881 2.60588 2.51907C0.785291 4.27901 0.222421 6.40669 0.102083 8.80832C-0.0182547 10.8797 0.00115464 12.9324 0.00115464 15C0.00115464 17.0676 -0.0182547 19.124 0.102083 21.1917C0.222421 23.5933 0.789172 25.7247 2.60588 27.4809C4.42648 29.2409 6.62749 29.785 9.11188 29.9013C11.2547 30.0176 13.378 29.9989 15.517 29.9989C17.6597 29.9989 19.7831 30.0176 21.922 29.9013C24.4064 29.785 26.6113 29.2371 28.428 27.4809C30.2486 25.721 30.8115 23.5933 30.9318 21.1917C31.056 19.124 31.0328 17.0714 31.0328 15ZM27.6167 23.8485C27.3333 24.5314 26.9917 25.0418 26.4444 25.5671C25.897 26.0962 25.373 26.4265 24.6665 26.7004C22.6246 27.4847 17.7762 27.3083 15.5131 27.3083C13.2499 27.3083 8.39762 27.4847 6.35576 26.7042C5.64926 26.4302 5.12133 26.1 4.57787 25.5709C4.03053 25.0418 3.68892 24.5352 3.40555 23.8522C2.59812 21.8746 2.78057 17.1877 2.78057 15C2.78057 12.8123 2.59812 8.1216 3.40555 6.14777C3.68892 5.46481 4.03053 4.95446 4.57787 4.42911C5.12521 3.90375 5.64926 3.56978 6.35576 3.29584C8.39762 2.51532 13.2499 2.69168 15.5131 2.69168C17.7762 2.69168 22.6285 2.51532 24.6704 3.29584C25.3769 3.56978 25.9048 3.9 26.4483 4.42911C26.9956 4.95822 27.3372 5.46481 27.6206 6.14777C28.428 8.1216 28.2456 12.8123 28.2456 15C28.2456 17.1877 28.428 21.8746 27.6167 23.8485Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
    </ContactSection>
  )
}

export default ContactInfo
